import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('bg') ? 'bg' : 'en';

  const toggle = () => {
    const next = currentLang === 'en' ? 'bg' : 'en';
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/[0.04] border border-white/[0.08] text-white/60 text-xs font-semibold hover:bg-white/[0.08] hover:text-white/80 transition-all"
      title={currentLang === 'en' ? 'Превключи на български' : 'Switch to English'}
    >
      <span className="text-sm">{currentLang === 'en' ? '🇬🇧' : '🇧🇬'}</span>
      <span>{currentLang === 'en' ? 'EN' : 'BG'}</span>
    </button>
  );
};

export default LanguageSwitcher;
